import { API_ROUTES } from '@/config';

import request from '@/services/request';

import currentModule from './current';

export default {
  namespaced: true,
  modules: {
    current: currentModule,
  },
  actions: {
    async fetchListWithoutStore({ dispatch }, { params } = {}) {
      const response = await request.get(API_ROUTES.eventsRecord.list, { params });

      dispatch('current/setStatus', response.status ?? {});

      return response;
    },

    fetchEventsListWithoutStore(context, { id, params } = {}) {
      return request.get(`${API_ROUTES.eventsRecord.list}/${id}`, { params });
    },

    createExport(context, { id, eventIds = [], eventPattern } = {}) {
      return request.post(`${API_ROUTES.eventsRecord.list}/${id}/exports`, { event_ids: eventIds, event_pattern: eventPattern });
    },

    fetchExport(context, { id } = {}) {
      return request.get(`${API_ROUTES.eventsRecord.export}/${id}`);
    },

    playback(context, { id, data } = {}) {
      return request.post(`${API_ROUTES.eventsRecord.list}/${id}/playback`, data);
    },

    stopPlayback(context, { id } = {}) {
      return request.delete(`${API_ROUTES.eventsRecord.list}/${id}/playback`);
    },

    remove(context, { id } = {}) {
      return request.delete(`${API_ROUTES.eventsRecord.list}/${id}`);
    },

    removeEvent(context, { id } = {}) {
      return request.delete(`${API_ROUTES.eventsRecord.event}/${id}`);
    },

    bulkRemoveEvent(context, { data }) {
      return request.delete(API_ROUTES.eventsRecord.bulkEvent, { data });
    },
  },
};
